export function NotFound({slug}: {slug?: string}) {
  return (
    <div className='flex min-h-screen items-center justify-center bg-neutral-50 px-6'>
      <div className='w-full max-w-md text-center'>
        <p className='text-sm font-semibold uppercase tracking-wide text-neutral-400'>Enrollment</p>
        <h1 className='mt-2 text-2xl font-semibold text-neutral-900'>We couldn't find that group</h1>
        <p className='mt-2 text-sm text-neutral-600'>
          {slug ? (
            <>
              No enrollment site is set up for <span className='font-medium'>"{slug}"</span>.
            </>
          ) : (
            'No group was specified.'
          )}
        </p>
      </div>
    </div>
  );
}
